import React from 'react';

function CursorWindsurfDifferenceContent() {
  return (
    <>
      <p>How Repo Prompt compares to other AI-assisted development tools like Cursor and Windsurf.</p>
      <h3>Key Differences</h3>
      <p>Repo Prompt emphasizes the experience of creating prompts and applying AI edits over everything else. It is not an IDE, though at this point it supports a lot of the features of one.</p>
      <p>Unlike those apps, system prompts are not hidden, and you can bring your own API keys to invoke providers directly. You are in full control over how the app interacts with AI models.</p>
    </>
  );
}

export default CursorWindsurfDifferenceContent;